module.exports = __webpack_public_path__ + "img/package-2.2297e1fb.png";